import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

import { appConfig } from '@app/config/appConfig';

export const initializeNewRelic = (): void => {
  const { newRelic } = appConfig.thirdParties;

  if (!newRelic.enabled || !newRelic.licenseKey) {
    return;
  }

  const nrOptions = {
    info: {
      applicationID: newRelic.applicationId,
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: newRelic.licenseKey,
      sa: 1,
    },
    init: {
      ajax: {
        deny_list: ['bam.nr-data.net'],
      },
      browser_consent_mode: {
        enabled: false,
      },
      distributed_tracing: {
        enabled: true,
      },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
      privacy: {
        cookies_enabled: true,
      },
    },
    loader_config: {
      accountID: newRelic.accountId,
      agentID: newRelic.agentId,
      applicationID: newRelic.applicationId,
      licenseKey: newRelic.licenseKey,
      trustKey: newRelic.trustKey,
    },
  };

  try {
    new BrowserAgent(nrOptions);
  } catch (error) {
    console.error('Failed to initialize New Relic Browser Agent', error);
  }
};
